export default "__VITE_ASSET__bmO8JzL4__"